import React from "react";

import Typography from "@mui/joy/Typography";
import Box from "@mui/joy/Box";

// components
import withNavigate from "../../utils/withNavigate";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import UserAvatar from "../Common/UserAvatar";


class ProfileMini extends React.Component {
    static contextType = UserSubscriberContext

    render() {
        return(
            <Box
                sx={{
                    p: 1,
                    mt: 'auto',
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center'
                }}
                key={'ProfileMini'+this.context.userObject.id}
            >
                <UserAvatar />
                <Box
                    sx={{ml: 2}}
                >
                    <Typography
                        fontWeight="lg"
                        level="body-sm"
                    >
                        {this.context.userObject.first_name} {this.context.userObject.last_name}
                    </Typography>
                    <Typography
                        level="body-sm"
                    >@{this.context.userObject.username}</Typography>
                </Box>
            </Box>
        )
    }
}

export default withNavigate(ProfileMini);
